import {createAxiosInstance} from './base.api'

const subtaskApi = 'subtasks'

export const getSubtask = (id, errorMethod) => createAxiosInstance(subtaskApi).get(`/${id}`)
.catch(error => errorMethod(error))

export const subtaskOrderUp = (id, errorMethod) => createAxiosInstance(subtaskApi).put(`/${id}/order-up`, {})
.catch(error => errorMethod(error))

export const subtaskOrderDown = (id, errorMethod) => createAxiosInstance(subtaskApi).put(`/${id}/order-down`, {})
.catch(error => errorMethod(error))

export const subtaskStart = (id, errorMethod) => createAxiosInstance(subtaskApi).put(`/${id}/start`, {})
.catch(error => errorMethod(error))

export const subtaskFinish = (id, errorMethod) => createAxiosInstance(subtaskApi).put(`/${id}/finish`, {})
.catch(error => errorMethod(error))

export const subtaskCancel = (id, errorMethod) => createAxiosInstance(subtaskApi).put(`/${id}/cancel`, {})
.catch(error => errorMethod(error))

export const subtaskDelete = (id, errorMethod) => createAxiosInstance(subtaskApi).delete(`/${id}`, {})
.catch(error => errorMethod(error))

export const updateSubtask = (id, subtask, successMethod, errorMethod) => createAxiosInstance(subtaskApi).put(`/${id}`, subtask)
.then(response => successMethod(response))
.catch(error => errorMethod(error))
